import { makeAutoObservable, runInAction } from "mobx";
import { AuthorizationModel, CurrentUser } from "./authorization_model";
import { AuthorizationHttpRepository } from "./authorization_http_repository";
import { httpSession, onUnauthorized, resetHttpSession } from "../../core/repository/http_session";

export class AuthorizationStore {
  authorizationModel = AuthorizationModel.empty();
  repository = new AuthorizationHttpRepository();
  user: CurrentUser | null = null;
  isInitialized = false;
  isLoading = false;
  errorMessage = "";
  private pendingRestore?: Promise<void>;
  private unsubscribe: () => void;
  constructor() {
    makeAutoObservable(this, { repository: false } as any);
    this.unsubscribe = onUnauthorized(() => runInAction(() => { this.user = null; this.isInitialized = true; }));
  }
  restore = async () => {
    if (this.isInitialized) return;
    if (this.pendingRestore) return this.pendingRestore;
    this.isLoading = true;
    this.errorMessage = "";
    this.pendingRestore = (async () => {
      try {
        const result = await this.repository.me();
        runInAction(() => {
          if (result.isSuccess()) this.user = result.getOrThrow().user;
          else if (result.error.status !== 401) this.errorMessage = result.error.message;
          this.isInitialized = true;
        });
      } catch { runInAction(() => { this.errorMessage = "Не удалось проверить вход. Повторите попытку"; this.isInitialized = true; }); }
      finally { runInAction(() => { this.isLoading = false; this.pendingRestore = undefined; }); }
    })();
    return this.pendingRestore;
  };
  retry = async () => { this.isInitialized = false; await this.restore(); };
  onTapLogin = async () => {
    if (this.isLoading) return;
    const validation = this.authorizationModel.isValid();
    if (validation.isFailure()) { this.errorMessage = validation.error; return; }
    this.isLoading = true;
    this.errorMessage = "";
    try {
      const result = await this.repository.login(this.authorizationModel.login, this.authorizationModel.password);
      runInAction(() => {
        if (result.isSuccess()) {
          const response = result.getOrThrow();
          this.user = response.user;
          httpSession.csrfToken = response.csrfToken;
          this.authorizationModel.password = "";
          this.isInitialized = true;
        } else this.errorMessage = result.error.message;
      });
    } catch { runInAction(() => { this.errorMessage = "Не удалось войти. Проверьте соединение"; }); }
    finally { runInAction(() => { this.isLoading = false; }); }
  };
  logout = async () => {
    if (this.isLoading) return;
    this.isLoading = true;
    this.errorMessage = "";
    try {
      const result = await this.repository.logout();
      runInAction(() => {
        if (result.isSuccess() || (result.isFailure() && result.error.status === 401)) {
          resetHttpSession(); this.user = null; this.authorizationModel = AuthorizationModel.empty();
        } else if (result.isFailure()) this.errorMessage = result.error.message;
      });
    } catch { runInAction(() => { this.errorMessage = "Не удалось выйти. Повторите попытку"; }); }
    finally { runInAction(() => { this.isLoading = false; }); }
  };
  changeLogin = (value: string) => { this.authorizationModel.login = value; };
  changePassword = (value: string) => { this.authorizationModel.password = value; };
  dispose() { this.unsubscribe(); }
}
export const authorizationStore = new AuthorizationStore();
